import Cookie from 'js-cookie';

import { MARKET_SEGMENT_COOKIE } from '~/features/cookies/constants';

/**
 * Returns true when Session Replay is allowed based on the viewer's market
 * segment cookie. Only purely consumer users (or users without a segment set)
 * should be recorded. Multi-segment values or any non-consumer segment block
 * initialization.
 */
export function isSessionReplayAllowedForMarketSegment(): boolean {
  if (typeof window === 'undefined') return false;

  const cookieValue = Cookie.get(MARKET_SEGMENT_COOKIE);

  if (!cookieValue) return true;

  const trimmed = cookieValue.trim();
  if (!trimmed) return true;

  const lower = trimmed.toLowerCase();
  return lower === 'consumer' || lower === 'none';
}
